import React from 'react';
import PropTypes from 'prop-types';
import 'dayjs/locale/sk';
import { TimePicker } from 'antd';

const SimpleTimePicker = ({ value, onChange, classes, ...rest }) => {
  return (
    <TimePicker
      {...rest}
      value={value}
      onChange={(newValue) => onChange(newValue)}
      className={classes}
      placeholder={` - `}
      locale="sk"
    />
  );
};

SimpleTimePicker.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  classes: PropTypes.array,
};

export default SimpleTimePicker;
